import { common } from '@ocean/ui'
import { TextWrapper } from './ListItemTitle.styled'

const { Typography } = common

export type ListItemTitleProps = {
  title?: Nullable<string>
  dataTest?: string
}

const ListItemTitle: React.FC<ListItemTitleProps> = ({ title, dataTest }) => {
  if (!title) return null
  return (
    <Typography variant='p'>
      <TextWrapper data-test={dataTest}>{title}</TextWrapper>
    </Typography>
  )
}

export default ListItemTitle
